// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding-container {    
    margin:20px 40px;
}
.pricing-container{
    display: flex;
    flex-wrap: wrap;
    gap:16px
}`, "",{"version":3,"sources":["webpack://./src/Pages/Onboarding.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,eAAe;IACf;AACJ","sourcesContent":[".onboarding-container {    \n    margin:20px 40px;\n}\n.pricing-container{\n    display: flex;\n    flex-wrap: wrap;\n    gap:16px\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
